import { FC } from "react";

const BRAND = "#2563eb";

interface FooterLinks {
  [key: string]: string[];
}

const footerLinks: FooterLinks = {
  // Tools: ["Compress PDF", "Merge PDF", "Split PDF", "Edit PDF", "Sign PDF", "Convert PDF"],
  // Convert: ["PDF to Word", "PDF to Excel", "PDF to PPT", "JPG to PDF", "Word to PDF"],
  // Company: [],
  // Support: ["Help Center", "Community", "Status", "Privacy Policy", "Terms of Service"],
};

const Footer: FC = () => {
  return (
    <footer style={{ borderTop: "1px solid #f0ede8", background: "#fff" }}>
      {/* Main footer */}
      <div style={{ padding: "48px 40px", display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr", gap: 32 }}>
        {/* Brand col */}
        <div>
          {/*<div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 20, fontWeight: 700, color: BRAND, marginBottom: 14 }}>*/}
          {/*  <span>📄</span> EasyPDF*/}
          {/*</div>*/}
          {/*<p style={{ fontSize: 14, color: "#888", lineHeight: 1.7, maxWidth: 240 }}>*/}
          {/*  A free solution to all your PDF problems. Making documents easy since 2026.*/}
          {/*</p>*/}
          {/*<div style={{ display: "flex", gap: 12, marginTop: 20 }}>*/}
          {/*  {["🐦", "💼", "📘", "📸"].map((icon, i) => (*/}
          {/*    <div key={i} style={{*/}
          {/*      width: 34, height: 34, borderRadius: 8, background: "#f0f4ff",*/}
          {/*      display: "flex", alignItems: "center", justifyContent: "center",*/}
          {/*      fontSize: 16, cursor: "pointer", transition: "background 0.15s",*/}
          {/*    }}*/}
          {/*      onMouseEnter={(e) => e.currentTarget.style.background = "#dbeafe"}*/}
          {/*      onMouseLeave={(e) => e.currentTarget.style.background = "#f0f4ff"}>*/}
          {/*      {icon}*/}
          {/*    </div>*/}
          {/*  ))}*/}
          {/*</div>*/}
        </div>

        {/* Link columns */}
        {Object.entries(footerLinks).map(([heading, links]) => (
          <div key={heading}>
            <h4 style={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a", marginBottom: 16, textTransform: "uppercase", letterSpacing: 0.5 }}>
              {heading}
            </h4>
            <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
              {links.map((link) => (
                <li key={link}>
                  <a href="#" style={{ fontSize: 13, color: "#888", textDecoration: "none", transition: "color 0.15s" }}
                    onMouseEnter={(e) => (e.currentTarget as HTMLAnchorElement).style.color = BRAND}
                    onMouseLeave={(e) => (e.currentTarget as HTMLAnchorElement).style.color = "#888"}>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div style={{
        borderTop: "1px solid #f0ede8", padding: "18px 40px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        fontSize: 13, color: "#aaa",
      }}>
        <span>© 2026 EasyPDF. All rights reserved.</span>
        <div style={{ display: "flex", gap: 20 }}>
          <a href="#" style={{ color: "#aaa", textDecoration: "none" }}>Privacy</a>
          <a href="#" style={{ color: "#aaa", textDecoration: "none" }}>Terms</a>
          <a href="#" style={{ color: "#aaa", textDecoration: "none" }}>Cookies</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

